import React, { useContext, useState } from 'react';
import { Form, Card } from 'antd';
import { PageHeader } from '@ant-design/pro-components';
import Partform from 'components/Partform/Partform';
import './Createpart.scss';
import { observer } from 'mobx-react';
import { rootContext } from 'stores';
import {
  IfileUploadHookReturn,
  useFileUploadHook
} from 'hooks/FileUpload.hook';
import { RouteConfigs } from 'config/routes';
import {
  allowedType,
  allowedTypePart,
  isSubModelsValid,
  toast,
  toastTypeEnum
} from 'common/utils';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

export type ISubModelInputs = {
  subModel: string;
  file?: File | undefined | null;
};


const Createpart: React.FC = observer(() => {
  const {
    PartsStore: {
      addParts,
      state: {
        ui: { addPartsLoading }
      }
    }
  } = useContext(rootContext);

  const navigate = useNavigate();
  const [subModelInputs, setSubModelInputs] = useState<ISubModelInputs[]>([]);

  const [createPartForm] = Form.useForm();
  const [autoIncrement, setAutoIncrement] = useState(false);
  const [svgFile, setSvgFile] = useState({});
  const partSvgFileUploadHook: IfileUploadHookReturn = useFileUploadHook(
    allowedTypePart
  );

  const carModelFileUploadHook: IfileUploadHookReturn = useFileUploadHook(
    allowedType
  );

  const saveFileContent = (fileContent: string) => {
    let blob = new Blob([fileContent], { type: 'image/svg+xml' });
    var file = new File([blob], 'image.svg');
    setSvgFile(file);
  };

  const onSubmit = async (values: any) => {
    if (!isSubModelsValid(subModelInputs, true)) {
      return;
    }
    if (partSvgFileUploadHook.fileList.length < 1) {
      return toast(toastTypeEnum.error, 'Part is required');
    }

    for (const item of subModelInputs) {
      // console.log('item: ', item);
      values[item.subModel] = item.file;
    }
    const data = await addParts({
      ...values,
      startMakingYear: dayjs(values.makingYear[0]).format('YYYY'),
      endMakingYear: !autoIncrement ? dayjs(values.makingYear[1]).format('YYYY') : null,
      submodel: values.submodel,
      region: values.region,
      file: svgFile,
      model_image: carModelFileUploadHook.fileList[0]
    });
    if (data === true) {
      createPartForm.resetFields();
      partSvgFileUploadHook.onRemove();
      carModelFileUploadHook.onRemove();
    }
  };

  return (
    <div className="CreatepartStyles">
      <div className="cardWrapeer">
        <Card>
          <PageHeader
            title="Create Part"
            onBack={() => navigate(RouteConfigs.index.path, { replace: true })}
          />
          <div className="PartForm">
            <Partform
              autoIncrement={autoIncrement}
              setAutoIncrement={setAutoIncrement}
              form={createPartForm}
              onSubmit={onSubmit}
              saveFileContent={saveFileContent}
              regionIds={[]}
              loading={addPartsLoading}
              partSvgFileUploadHook={partSvgFileUploadHook}
              carModelFileUploadHook={carModelFileUploadHook}
              mode="add"
              subModelInputs={subModelInputs}
              setSubModelInputs={setSubModelInputs}
            />
          </div>
        </Card>
      </div>
    </div>
  );
});

export default Createpart;
